const e = "_linkButton_1kek8_1", n = "_primary_1kek8_5", _ = "_neutral_1kek8_18", s = "_danger_1kek8_25", k = "_inversed_1kek8_32", t = "_disabled_1kek8_39", l = "_small_1kek8_43", a = "_loader_1kek8_46", d = "_medium_1kek8_50", i = "_spin_1kek8_1", r = {
  linkButton: e,
  primary: n,
  neutral: _,
  danger: s,
  inversed: k,
  disabled: t,
  small: l,
  loader: a,
  medium: d,
  spin: i
};
export {
  s as danger,
  r as default,
  t as disabled,
  k as inversed,
  e as linkButton,
  a as loader,
  d as medium,
  _ as neutral,
  n as primary,
  l as small,
  i as spin
};
//# sourceMappingURL=LinkButton.module.scss.js.map
